var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-go-top-button",class:{ active: _vm.boolActive },on:{"click":_vm.click}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('i',{staticClass:"fa fa-chevron-up"})])
}]

export { render, staticRenderFns }